import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { BaseComponent } from "src/app/shared/components/base/base.component";
import { SnackbarService } from "src/app/shared/components/snackbar/service/snackbar.service";
import { I18nService } from "src/app/shared/i18n/service/i18n.service";
import { SubSink } from "subsink";
import {
  ChangePasswordBody,
  ChangePasswordAndMailResponse,
} from "../../model/profile.model";
import { ProfileService } from "../../service/profile.service";
import { HeadingWidgetComponent } from "src/app/shared/components/heading-widget/heading-widget.component";
import { MaterialModule } from "src/app/shared/module/material.module";
import { I18nPipe } from "src/app/shared/i18n/pipe/i18n.pipe";
import { CommonModule } from "@angular/common";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: "ald-change-password",
    templateUrl: "./change-password.component.html",
    styleUrls: ["./change-password.component.scss"],
    imports: [
        HeadingWidgetComponent,
        MaterialModule,
        ReactiveFormsModule,
        I18nPipe,
        CommonModule
    ]
})
export class ChangePasswordComponent
  extends BaseComponent
  implements OnInit, OnDestroy {
  changePasswordForm: UntypedFormGroup;
  changePasswordRequest = {} as ChangePasswordBody;
  private subs = new SubSink();
  hideOld = true;
  hideNew = true;
  constructor(
    public dialogRef: MatDialogRef<ChangePasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private fb: UntypedFormBuilder,
    private i18n: I18nService,
    private profileService: ProfileService,
    private snack: SnackbarService
  ) {
    super();

    dialogRef.disableClose = true;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  translate(label): string {
    return this.i18n.getTranslation(label);
  }

  ngOnInit() {
    this.loadForm();
    this.oldPasswordValueChange();
    this.newPasswordValueChange();
  }

  close() {
    this.dialogRef.close();
  }

  getErrorMessage(label): string {
    let errorMessageToShow =
      this.control(this.changePasswordForm, label).value.length === 0
        ? this.i18n.getTranslation("mandatory_field")
        : this.i18n.getTranslation("pattern_error");
    errorMessageToShow =
      this.control(this.changePasswordForm, label).value.length < 8
        ? this.i18n.getTranslation("short_password_setted")
        : errorMessageToShow;
    errorMessageToShow = this.control(this.changePasswordForm, label).value.length >= 16
      ? this.i18n.getTranslation("long_password_setted") : errorMessageToShow;

    return this.capitalizeFirstLetter(
      `${errorMessageToShow} , ${this.getAliasTransaletAndCapitalizedFirstLetter(
        label
      )}`
    );
  }

  getAliasTransaletAndCapitalizedFirstLetter(alias): string {
    return this.capitalizeFirstLetter(this.i18n.getTranslation(alias));
  }

  loadForm() {
    this.changePasswordForm = this.fb.group({
      oldPassword: ["", Validators.required],
      newPassword: ["", this.validatorsPassword()],
    });
    this.control(this.changePasswordForm, "newPassword").disable();
  }

  oldPasswordValueChange() {
    this.subs.add(
      this.valueChanges(this.changePasswordForm, "oldPassword").subscribe(
        (oldPasswordValueChanged) => {
          this.changePasswordRequest.oldPassword = oldPasswordValueChanged;
          this.control(this.changePasswordForm, "newPassword").enable();
        }
      )
    );
  }

  newPasswordValueChange() {
    this.subs.add(
      this.valueChanges(this.changePasswordForm, "newPassword").subscribe(
        (newPasswordValueChanged) => {
          this.changePasswordRequest.newPassword = newPasswordValueChanged;
        }
      )
    );
  }

  openSnack(message: string, type: string) {
    const snackData: any = {};
    snackData.message = message;
    snackData.type = type;
    this.snack.openSnackBar(snackData);
  }

  submit() {
    this.subs.add(
      this.profileService
        .changePassword(this.changePasswordRequest)
        .subscribe((passwordChanged: ChangePasswordAndMailResponse) => {
          if (!!passwordChanged.error) {
            const message = passwordChanged.error.description;
            this.openSnack(message, "rfc-danger");
            this.dialogRef.close();
          } else {
            const message = passwordChanged.message;
            this.openSnack(message, "rfc-success");
            this.dialogRef.close();
          }
        })
    );
  }
}
